import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import { RexSpellingProgressEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/spelling-progress/events-detailed'
import { RexSpellingProgressOverview } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/spelling-progress/overview'
import type {
  SpellingProgressOverviewReportData,
  SpellingProgressEventsReportData,
} from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import type { Task } from 'ember-concurrency'

interface Args {
  fetchSpellingProgressOverviewReportTask: Task<SpellingProgressOverviewReportData | undefined, unknown[]>
  fetchSpellingProgressEventsReportTask: Task<SpellingProgressEventsReportData | undefined, unknown[]>
}

interface Signature {
  Args: Args
}
export const DashboardStudentSpellingProgressPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="spelling-lesson-progress"
    @theme={{themeKey "reading"}}
    @title={{t "pages.reporting.readingEggspress.dashboard.student.spellingLessons.title"}}
    @icon="phosphor-share-network-fill"
  >
    <TaskState @task={{@fetchSpellingProgressOverviewReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <RexSpellingProgressOverview class="w-full" @overviewData={{lastValue.overview}} @isLoading={{isRunning}} />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState @task={{@fetchSpellingProgressEventsReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <RexSpellingProgressEventsDetailed class="w-full" @eventsData={{lastValue.events}} @isLoading={{isRunning}} />
      <BasePageSelector
        class="my-4"
        @pageCount={{lastValue.meta.total_pages}}
        @itemCount={{lastValue.meta.total_entries}}
      />
    </TaskState>
  </StudentDashboardTile>
</template>

export default DashboardStudentSpellingProgressPage
